import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

import { SideNavFilterComponent } from '@shared/side-nav-filter/side-nav-filter.component';
import { SideNavModule } from '@shared/side-nav/side-nav.module';

const components = [SideNavFilterComponent];
@NgModule({
  declarations: components,
  imports: [CommonModule, MatButtonModule, SideNavModule],
  exports: components,
})
export class SideNavFilterModule {}
